import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cmn-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss']
})
export class CardHeaderComponent implements OnInit {
  @HostBinding('class.with-filters') @Input() filters: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
